module.exports = __webpack_public_path__ + "img/try_1.3c43a465.png";